import GnbDivider from './GnbDivider';
import GnbMenuItem from './GnbMenuItem';
import GuideMenu from './GuideMenu';
import HelpdeskMenu from './HelpdeskMenu';
import NotificationMenu from './NotificationMenu';
import OrganizationMenu from './OrganizationMenu';
import RegionMenu from './RegionMenu';
import SettingMenu from './SettingMenu';
import UserMenu from './UserMenu';

const GnbRightSideComponent = () => {
  return (
    <GnbMenuItem>
      <RegionMenu />
      <GnbDivider />
      <NotificationMenu />
      <OrganizationMenu />
      <GuideMenu />
      <HelpdeskMenu />
      <SettingMenu />
      <GnbDivider />
      <UserMenu />
    </GnbMenuItem>
  );
};

export default GnbRightSideComponent;
